import moment from "moment";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";

interface FieldBlockProps {
  label: string;
  value: any;
  date?: boolean;
  price?: boolean;
  image?: boolean;
}

const DATE_FORMAT = "MMMM Do, YYYY";

const FieldBlock = ({ label, value, date, price, image }: FieldBlockProps) => {
  const { t } = useTranslation();
  if (date) {
    value = value ? moment(value).format(DATE_FORMAT) : "-";
  } else if (price) {
    value = value ? "$" + value : "-";
  }

  return (
    <div className="grid grid-cols-2 items-center">
      <p className="font-medium text-black text-sm">{t(label)}</p>
      {image ? (
        renderImageORPDF(value)
      ) : (
        <p className="text-sm">{value || "-"}</p>
      )}
    </div>
  );
};

export const renderImageORPDF = (url) => {
  if (!url) return <p className="text-sm">-</p>;
  const fileName = url?.split("/")?.pop();
  const extension = fileName?.substring(fileName.lastIndexOf(".") + 1);
  const ISPDF = extension?.toLowerCase() === "pdf";
  return ISPDF ? (
    <FaFilePdf className="size-12 object-cover mr-2" />
  ) : (
    <div className="flex items-center gap-4 mt-1">
      <img
        src={url}
        alt=""
        className="size-16 bg-gray-100 rounded-md cursor-pointer object-cover"
      />
    </div>
  );
};

export default FieldBlock;
